import { LitElement, html, css, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { BackendPlan, networkDescriptions2026 } from '../util/plans';
import type { BackendFormResponse } from '../util/api';
import { inputResponseContext } from '../contexts/inputResponse';
import { getHeatmapImgSrc, getHeatmapTooltip } from '../util/heatmap';
import { consume } from '@lit/context';
import { breakpointContext } from '../contexts/breakpoint';
import { BREAKPOINT } from '../util/breakpoints';
@customElement('rq-heatmap')
export class HeatMap extends LitElement {
    static styles = css`
        .heatmap {
            width: var(--rq-heatmap-width, 200px);
            max-width: 300px;
        }
        .align-tooltip {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
        }
    `;
    @consume({ context: inputResponseContext, subscribe: true })
    @state()
    inputResponse!: BackendFormResponse;

    @property()
    plan!: BackendPlan;

    @property()
    width?: string;

    @consume({ context: breakpointContext, subscribe: true })
    @state()
    breakpoint!: BREAKPOINT;

    get imgSrc() {
        return getHeatmapImgSrc(this.plan);
    }

    connectedCallback(): void {
        super.connectedCallback();
        if (!this.width) return;
        this.style.setProperty('--rq-heatmap-width', this.width || '100px');
    }

    updated(changedProperties: Map<string, unknown>) {
        if (changedProperties.has('width')) {
            this.style.setProperty('--rq-heatmap-width', this.width || '100px');
        }
    }

    get isMobile() {
        return this.breakpoint === BREAKPOINT.PHONE || this.breakpoint === BREAKPOINT.TABLET;
    }

    render() {
        const networkDescription = networkDescriptions2026[this.plan.lobCode];
        return this.imgSrc
            ? html` <div class="align-tooltip">
                  <rq-tooltip
                      hide-line
                      position=${this.isMobile ? 'top' : 'left'}
                      .description=${`<div style="width: 300px;">${getHeatmapTooltip(this.plan)}</div>`}
                  >
                      <div class="heatmap">
                          <lh-image class="img" aria-description=${networkDescription} full-width src=${this.imgSrc}> </lh-image>
                      </div>
                  </rq-tooltip>
                  </div>
              </div>`
            : nothing;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'rq-heatmap': HeatMap;
    }
}
